export type LaunchFailure = {
  message: string;
  retryable: boolean;
  retryAt: number;
  activeAppId?: string;
  notFound: boolean;
};

export function launchFailureDetails(cause: unknown, now = Date.now()): LaunchFailure {
  const error = cause as { status?: number; code?: string; retryAfterSeconds?: number; activeAppId?: string } | null;
  const code = error?.code;
  const notFound = error?.status === 404;
  const message = notFound ? "App not found. It may have been removed."
    : code === "public_try_browser_concurrency" ? "Another Try is still running in this browser. Return to it and stop it before starting another."
    : code === "public_try_ip_rate_limit" ? "Too many Tries have started from this network in the past hour. Wait before trying again."
    : code === "public_try_capacity_exhausted" ? "There are no execution slots available right now. Try again or choose another app."
    : code === "public_try_capacity_or_rate_limit" ? "A Try limit was reached. Wait before trying again or return to your running Try."
    : "The app didn't open. Try again, or go back to the app list.";
  const seconds = error?.retryAfterSeconds;
  return {
    message,
    retryable: !notFound,
    retryAt: error?.status === 429 ? now + Math.max(10, Number.isFinite(seconds) ? Math.min(seconds!, 86_400) : 10) * 1_000 : 0,
    activeAppId: typeof error?.activeAppId === "string" && /^[A-Za-z0-9][A-Za-z0-9._-]{0,127}$/.test(error.activeAppId) ? error.activeAppId : undefined,
    notFound,
  };
}
